<template>
  <div>
    <div class="contentBox w">
      <div class="contentStitle">Method of cooperation</div>
      <div class="contentTitle">合作方式</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="form_box">
        <el-form :model="form" :rules="rules" ref="form" label-width="120px">
          <el-form-item label="企业名称：" prop="company">
            <el-input v-model="form.company" placeholder="请输入您的企业名称"></el-input>
          </el-form-item>
          <el-form-item label="您的名字：" prop="name">
            <el-input v-model="form.name" placeholder="请输入您的姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" prop="mobile">
            <el-input v-model="form.mobile" placeholder="请输入您的手机号"></el-input>
          </el-form-item>
          <el-form-item label="需求项目：" prop="requirement">
            <el-input
              v-model="form.requirement"
              placeholder="请输入您的需求项目"
            ></el-input>
          </el-form-item>
          <el-form-item class="btnBox">
            <el-button type="danger" @click="onSubmit('form')">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="mobile_contentBox">
      <!-- <div class="contentStitle">Method of cooperation</div> -->
      <div class="contentTitle noStitle">合作方式</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="form_box">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px">
          <el-form-item label="企业名称：" prop="company">
            <el-input v-model="form.company" placeholder="请输入您的企业名称"></el-input>
          </el-form-item>
          <el-form-item label="您的名字：" prop="name">
            <el-input v-model="form.name" placeholder="请输入您的姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" prop="mobile">
            <el-input v-model="form.mobile" placeholder="请输入您的手机号"></el-input>
          </el-form-item>
          <el-form-item label="需求项目：" prop="requirement">
            <el-input
              v-model="form.requirement"
              placeholder="请输入您的需求项目"
            ></el-input>
          </el-form-item>
          <el-form-item class="btnBox">
            <el-button type="danger" @click="onSubmit('form')">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import axios from "axios";
export default {
  data() {
    return {
      form: {
        company: "",
        name: "",
        mobile: "",
        requirement: "",
      },
      rules: {
        company: [{ required: true, message: "请输入您的企业名称", trigger: "blur" }],
        name: [
          { required: true, message: "请输入您的姓名", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请输入您的手机号", trigger: "blur" },
          { min: 11, max: 11, message: "长度在 11 个字符", trigger: "blur" },
        ],
        requirement: [{ required: true, message: "请输入您的需求项目", trigger: "blur" }],
      },
    };
  },
  methods: {
    onSubmit(form) {
      var _this = this;
      _this.$refs[form].validate((valid) => {
        if (valid) {
          // var form = JSON.stringify(this.form);
          axios
            .post(process.env.VUE_APP_URL + "/api/news/submit", _this.form)
            .then(function (response) {
              if (response.data.code == 0) {
                _this.$message({
                  message: response.data.msg,
                  type: "success",
                });
                _this.form.company = "";
                _this.form.name = "";
                _this.form.mobile = "";
                _this.form.requirement = "";
              } else {
                _this.$message({
                  message: response.data.msg,
                  type: "error",
                });
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 999px) {
  .form_box {
    width: 350px;
    height: 350px;
    border: 2px solid #da261d;
    border-radius: 20px;
    margin: 20px auto;
    padding: 30px 10px;
    .btnBox {
      text-align: left;
    }
  }
}
@media screen and (min-width: 1000px) {
  .form_box {
    width: 859px;
    height: 504px;
    border: 2px solid #da261d;
    border-radius: 20px;
    margin: 80px auto;
    padding: 50px;
    .btnBox {
      text-align: left;
    }
  }
}
</style>
